<!-- 出発駅(予約変更画面) -->
<template>
  <div class="row">
    <div class="th cell">出発駅</div>
    <div class="cell">{{ stationName }}</div>
  </div>
</template>

<script>
export default {
  name: "MFITTFromStation",
  props: {
    stationName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
</style>
